/* Best Pendulum Theme JS */
'use strict';

// Sticky nav scroll effect
const header = document.querySelector('.site-header');
if (header) {
  window.addEventListener('scroll', () => {
    if (window.scrollY > 40) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  }, { passive: true });
}

// Live cart count
fetch('/cart.js')
  .then(r => r.json())
  .then(cart => {
    const el = document.getElementById('cart-count');
    if (el) el.textContent = `Cart (${cart.item_count})`;
  })
  .catch(() => {});

// Cart count update
document.querySelectorAll('[data-cart-count]').forEach(el => {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => { el.textContent = `Cart (${cart.item_count})`; })
    .catch(() => {});
});

// Add to cart buttons
document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
  btn.addEventListener('click', function() {
    const variantId = this.dataset.variantId;
    if (!variantId) return;
    this.textContent = 'Adding...';
    this.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(r => r.json())
    .then(() => {
      this.textContent = '✓ Added to Cart';
      this.style.background = '#27AE60';
      setTimeout(() => {
        this.textContent = 'Add to Cart';
        this.style.background = '';
        this.disabled = false;
      }, 2500);
      // Update cart count
      return fetch('/cart.js');
    })
    .then(r => r.json())
    .then(cart => {
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = `Cart (${cart.item_count})`;
      });
    })
    .catch(() => {
      this.textContent = 'Add to Cart';
      this.disabled = false;
    });
  });
});
